(function () {
    'use strict';

    angular.module("imApp").factory("businessSitesService", [function () {
        let service = {};

        return service;
    }]);
})();
